import {
  WORKSPACE_FRAME_BORDER_WIDTH,
  WORKSPACE_FRAME_PADDING,
  WORKSPACE_PADDING,
} from '@components/v2/constants';
import { DETAILS_PANEL_WIDTH } from '@components/v2/layout/ObjectScreen/components/DetailsPanel';
import { Theme } from '@mui/material';
import { NavSection } from './appTemplate.types';

export const hasVisibleNavItems = (sections: NavSection[]) =>
  sections.some((section) => section.items.some((item) => !item.hidden));

const DETAILS_PANEL_SHARE_OF_CONTENT = 2;

export const getWorkspaceContentMinWidth = (theme: Theme) => {
  const detailsPanelMinWidth = DETAILS_PANEL_WIDTH + parseFloat(theme.spacing(WORKSPACE_PADDING));
  const contentAreaInset =
    parseFloat(theme.spacing(WORKSPACE_FRAME_PADDING)) + WORKSPACE_FRAME_BORDER_WIDTH;

  return detailsPanelMinWidth * DETAILS_PANEL_SHARE_OF_CONTENT + contentAreaInset * 2;
};
